import { createConfirmation } from 'react-confirm'
import ExtendedConfirmDialog from './ExtendedConfirmDialog'

// create confirm function
const confirm = createConfirmation(ExtendedConfirmDialog)

export default function(confirmation, options = {}) {
    return confirm({ confirmation, options })
}
